import client from "./axiosConfig";

export const createTask = (data) => {
  const config = {
    url: "/task_manager/task/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const getTask = (params) => {
  const config = {
    url: "/task_manager/task/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const getTaskById = (id) => {
  const config = {
    url: `/task_manager/task/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const postComments = (id, data) => {
  const config = {
    url: `/task_manager/task/${id}/comments/`,
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const updateTaskStatus = (taskId, data) => {
  const config = {
    url: `/task_manager/task/${taskId}/review/`,
    method: "PATCH",
    data,
  };
  return client(config);
};

export const uploadTaskFile = (taskId, formData) => {
  const config = {
    url: `/task_manager/task/${taskId}/`,
    method: "PATCH",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data", // Optional — axios sets this automatically with FormData
    },
  };
  return client(config);
};

export const getComments = (id, params) => {
  const config = {
    url: `/task_manager/task/${id}/comments/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const deleteTask = (id) => {
  return client({
    url: `/task_manager/task/${id}/`,
    method: "DELETE",
  });
};
